<template>
	<div class="item_sidebar border_item_sidebar container-props active">
		<div class="layout-column">
			<div class="__prop-entry" v-for="(prop, k) in propKeys" :key="`prop_`+k">
				<span class="flex title">{{prop}}</span>
				<label class="flex-none switch_checkbox_item">
					<input type="checkbox" :checked="props[k]"
					       @change="updatedData(k, $event.target.checked)">
					<div class="switch_checkbox"><span></span></div>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
import VSwitch from '@/components/base/v-switch'

export default {
	name: 'orderSummaryProps',
	props: ['title', 'value', 'content'],
	components: {
		VSwitch,
	},
	data: function () {
		return {
			propKeys: {
				'showImages':'Show images',
				'allowDiscountCodes':'Allow discount codes',
				'showHeader':'Show header','showTotal':'Show total',
				'collapsable':'Collapsable','isOpen':'Is open'
			},
			listItemsData: [],
			panelOpen: false,
			localData: {
				showImages: true,
				allowDiscountCodes: true,
				showHeader: false,
				showTotal: true,
				collapsable: true,
				isOpen: true,
			},
		}
	},
	computed: {
		basic() {
			return this.content.attributes.basic;
		},
		props() {
			return this.basic.props || {
				showImages: false,
				allowDiscountCodes: false,
				showHeader: true,
				showTotal: true,
				collapsable: false,
				isOpen: true,
			};
		}
	},
	methods: {
		updatedData(key, value) {
			this.$set(this.localData, key, value)
			this.$emit('updated', this.localData);
		},
		panelOpenToggle(){
			this.panelOpen = !this.panelOpen;
			localStorage.setItem(this.title, this.panelOpen);
		},
	},
	mounted() {
		if(localStorage.getItem(this.title) !== null) {
			if(localStorage.getItem(this.title) === 'true') {
				this.panelOpen = true;
			} else {
				this.panelOpen = false;
			}
		}
	},
	created() {
		try {
			this.localData = JSON.parse(JSON.stringify(this.value))
		} catch {
			this.localData = JSON.parse(JSON.stringify(this.localData))
		}
	},
}
</script>
<style lang="scss" scoped>
.__prop-entry {
	border-radius: 5px;
	padding: 5px 5px;
	flex-direction: row;
	align-items: center;
	display: flex;
	&:hover {
		background: $light-silver;
	}
}
.title {
	width: 110px;
	white-space: nowrap;
}
.v-select, .input-field {
	width: 100%;
}
</style>
